import React from "react";
import {Form, Input , Radio,InputNumber} from 'antd';
import NHFormItem from "../../common/NHFormItem";
import NHSelect from "../../common/NHSelect";
import NHFetch from "../../../utils/NHFetch";
const RadioGroup = Radio.Group;

const baseUrlPath = "/ksdh"; //学校信息管理模块路径

/**
 * 快速导航编辑表单
 */
class EditInitForm extends React.Component {

    static defaultProps = {
        initFormData:{},
    }

    constructor(props) {
        super(props);
        this.state = {
        }
    }



    changeRadioValue = (value)=>{
        const {setFieldsValue} = this.props.form;
        setFieldsValue({'zt':value});
    }

    render() {
        const {initFormData,zt0,zt1} = this.props;
        return (
                <form>

                    <NHFormItem id={"ljmc"} label={"链接名称"} initialValue={initFormData.ljmc} required={true}
                                pattern={{max: 100, message: "链接名称长度不能超过100字符！"}}
                                form={this.props.form}>
                        <Input  placeholder="链接名称" />
                    </NHFormItem>
                    <NHFormItem id={"ljdz"} label={"链接地址"} initialValue={initFormData.ljdz} required={true}
                                pattern={{max: 300, message: "链接地址长度不能超过300字符！"}}
                                form={this.props.form}>
                        <Input placeholder="链接地址" />
                    </NHFormItem>
                    <NHFormItem id={"ljlx"} label={"链接类别"} initialValue={initFormData.ljlx} required={true}
                                form={this.props.form}>
                        <NHSelect sign={"DMK_YXXT_LJLX"} style={{width:"100%"}} />
                    </NHFormItem>
                    <NHFormItem id={"pxh"} label={"排序号"} initialValue={initFormData.pxh ? initFormData.pxh : 1}
                                form={this.props.form}>
                        <InputNumber min={0} max={999999}/>
                    </NHFormItem>
                    <NHFormItem id={"zt"} label={"状态"} initialValue={initFormData.zt?initFormData.zt:'1'}
                                form={this.props.form}>
                        <RadioGroup onChange={(e)=>{this.changeRadioValue(e.target.value)}}>
                            <Radio value={"1"}>{zt1}</Radio>
                            <Radio value={"0"}>{zt0}</Radio>
                        </RadioGroup>
                    </NHFormItem>
                </form>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/ksdh/EditForm.js